module.exports = __webpack_public_path__ + "static/Illustration-60fe5e9c6de75f20a1b134aa9d40f8ee.png";